import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取日志列表
 * @param {参数} params
 * @returns
 */
export const getLogs = (params) => {
  return request({
    url: `${env.officeUrl}/log/list`,
    method: 'GET',
    params,
  })
}
